import { ButtonToolbar, OverlayTrigger, Tooltip } from "react-bootstrap";

import { buttonTypeConstants, toastMessages } from "../../../constants";
import Button from "./Button";

const ButtonWithToolTip = (props) => {
  const {
    label,
    isDisabled = false,
    placement = "bottom",
    tooltipBody = toastMessages.NO_RECORD_FOUND,
    //all props that are in button component are passed down
  } = props;

  const tooltip = <Tooltip id="tooltip-button">{tooltipBody}</Tooltip>;
  return isDisabled ? (
    <ButtonToolbar>
      {/* wrapper to avoid ref issues when disabled */}
      <OverlayTrigger placement={placement} overlay={tooltip}>
        <span>
          <Button
            label={label}
            isDisabled={true}
            buttonType={buttonTypeConstants.BLUE_BUTTON}
            {...props}
          />
        </span>
      </OverlayTrigger>
    </ButtonToolbar>
  ) : (
    <Button {...props} />
  );
};

export default ButtonWithToolTip;
